"use strict";

exports.__esModule = true;
exports.DeviceDataItemsContext = void 0;
var _Utils = require("../../../Utils");
/**
 * Provides a list of device date items to consumers.
 * @component
 */
var DeviceDataItemsContext = exports.DeviceDataItemsContext = (0, _Utils.createEnhancedContext)({
  propName: "dataItems"
});